"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewAggregateTelemetry extends new_item_1.default {
    constructor(newAggregateTelemetry) {
        super();
        this.consumption = newAggregateTelemetry.consumption;
        this.siteId = newAggregateTelemetry.siteId;
        this.time = newAggregateTelemetry.time;
    }
}
exports.default = NewAggregateTelemetry;
//# sourceMappingURL=new-aggregateTelemetry.js.map